import { createContext } from 'react';

// Internal Variable Context
const cmVariableContext =
  typeof window !== 'undefined' ? require('@readme/syntax-highlighter/dist').cmVariableContext : createContext();

const PermissionContext = createContext(false);
export { cmVariableContext, PermissionContext };
